<template>
  <nav>
    <button
      class="mobile-group-toggle"
      :class="{ '-active': isActive }"
      data-testid="navigation-group-mobile"
      @click="toggleMobileGroup(index)"
    >
      {{ item.label }}
      <span class="toggle-icon" :class="{ '-active': isActive }">
        <Icon icon="fa6-solid:angle-down" data-icon="fa6-solid:angle-down" />
      </span>
    </button>
    <transition name="slide-down">
      <ul v-if="activeMobileGroup === index" class="mobile-sublinks">
        <li
          v-for="(sublink, subIndex) in item.links"
          :key="sublink.label + '-' + subIndex"
        >
          <a
            :href="sublink.url"
            data-testid="navigation-sublink-mobile"
            @click="$emit('emittedClick', { type: 'link', el: sublink })"
          >
            {{ sublink.label }}
          </a>
        </li>
      </ul>
    </transition>
  </nav>
</template>

<script>
import { Icon } from "@iconify/vue";
import { navigationSlidedownMixins } from "./slidedownMixins.js";

export default {
  name: "NavigationUISlidedown",
  components: {
    Icon,
  },
  mixins: [navigationSlidedownMixins],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ["emittedClick", "toggle-group"],
};
</script>

<style lang="scss" scoped>
@import "./slidedown.scss";
</style>
